<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <app-lien :LienPageData='LienPage'></app-lien>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import Vue from 'vue';
    import 'vue-good-table/dist/vue-good-table.css';
    import EventBus from '../event-bus';
    import FrontFooter from '@/components/partials/FrontFooter';
    import ListLienComponent from "@/components/lien/ListLienComponent";
    import SessioMixin from '../../mixins/sessionmixin';
    export default {
        name: "lien",
        mixins: [SessioMixin],
        data: () => ({
                LienPage: {
                    pageTitle: 'Lien List',
                    perPage: 25,
                    cus_id: 0,
                    is_part: 0,
                    is_cust_detail: false,
                },
                loginID: 0,
                permissions: [],
                cantAccessPage: true,
            }),
        components: {
            'app-lien': ListLienComponent,
            'app-footer': FrontFooter,
        },
        beforeMount: function () {
            var self = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                self.isLoggedIn = true;
            }
        },
        mounted: function () {
            var initial = process.env.ROOT_API;
            var initial = initial.replace('/v1', '');
            $("#demourl").attr("href", initial + '/demo/Tasks.xlsx');
            $(".removeActive").removeClass('active');
            $("#menulien").addClass('active');
            this.showLoader();
            if (localStorage.getItem("menu_small") == '1') {
                this.menuSmall();
            } else {
                this.menuBig();
            }
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                this.loginID = userJson.id;
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
        },
        methods: {
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/lien/ShowLien.vue